<template>
    <div v-show="visible">
        <el-dialog title="导出按班级统计数据" :close-on-click-modal="false"
            v-loading="loading"
            :element-loading-text="loadingText"
            element-loading-spinner="el-icon-loading"
            :visible.sync="visible" width="480px">
            <el-form ref="form" :model="form" label-width="100px">
                <el-form-item prop="moduleId" label="评价模块">
                    <el-checkbox-group v-model="form.moduleArr">
                        <el-checkbox
                            v-for="item in moduleOptions"
                            :key="item.moduleId"
                            :label="item.moduleId"
                            style="width:110px;margin-bottom:8px;">
                            {{item.moduleTitle}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item prop="startDate" label="开始日期">
                    <el-date-picker
                        style="width:230px;"
                        v-model="form.startDate"
                        type="date"
                        placeholder="选择开始日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item prop="endDate" label="结束日期">
                    <el-date-picker
                        style="width:230px;"
                        v-model="form.endDate"
                        type="date"
                        placeholder="选择结束日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="exportData()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../common/http';

    export default {
        name: "ExportByClass",
        data(){
            return{
                visible: false,
                loading: false,
                loadingText: "",
                form:{
                    deptId: "",
                    moduleArr: [],
                    startDate: "",
                    endDate: ""
                },
                moduleOptions: []
            }
        },
        methods:{
            init(deptId, modules){
                this.visible = true;
                this.form.deptId = deptId;
                this.form.moduleArr = [];
                this.form.startDate = "";
                this.form.endDate = "";
                this.moduleOptions = modules || [];
                this.$nextTick(() => {
                    if(this.$refs['form']){
                        this.$refs['form'].clearValidate();
                    }
                });
            },
            exportData(){
                if(this.form.moduleArr.length === 0){
                    this.$commonFn.showTip('请选择评价模块', 3);
                    return;
                }
                if(this.$util.isEmpty(this.form.startDate)){
                    this.$commonFn.showTip('请选择开始日期', 3);
                    return;
                }
                if(this.$util.isEmpty(this.form.endDate)){
                    this.$commonFn.showTip('请选择结束日期', 3);
                    return;
                }

                this.loading = true;
                this.loadingText = "正在导出中，导出过程时间可能会比较长，请耐心等待";

                let url = this.evaluateDetailExportByClassUrl;
                let param = new URLSearchParams();
                param.append('deptId', this.form.deptId);
                param.append('moduleId', this.form.moduleArr.join(','));
                param.append('startDate', this.form.startDate);
                param.append('endDate', this.form.endDate);

                // 获取学校名称
                let schoolName = "";
                let depts = this.$parent.depts || [];
                for(let i = 0; i < depts.length; i++){
                    if(this.form.deptId === depts[i].id){
                        schoolName = depts[i].name;
                        break;
                    }
                }

                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", (schoolName ? schoolName + '-' : '') + '按班级统计数据.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading = false;
                    this.visible = false;
                }).catch(error => {
                    console.log(error);
                    this.$commonFn.showTip('导出失败，请稍后重试', 3);
                    this.loading = false;
                });
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/ExportByClass.vue